(function () {
  'use strict';

  function formatMoney(cents) {
    var value = cents / 100;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    try {
      return value.toLocaleString(undefined, { style: 'currency', currency: currency });
    } catch (err) {
      return '₹' + value.toFixed(2);
    }
  }

  /* ---------- Mobile nav ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-mobile-nav-toggle]');
    if (!toggle) return;
    var nav = document.querySelector('[data-mobile-nav]');
    if (!nav) return;
    var isOpen = !nav.hidden;
    nav.hidden = isOpen;
    toggle.setAttribute('aria-expanded', String(!isOpen));
  });

  /* ---------- Generic modal (data-modal-open / data-modal-close) ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-modal-open]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('data-modal-open'));
      if (target) target.hidden = false;
      return;
    }
    var closer = e.target.closest('[data-modal-close]');
    if (closer) {
      var modal = closer.closest('.nsc-modal, .nsc-popup');
      if (modal) modal.hidden = true;
    }
  });

  var DIALOG_SELECTOR = '.nsc-modal:not([hidden]), .nsc-popup:not([hidden]), .cart-drawer:not([hidden])';

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll(DIALOG_SELECTOR).forEach(function (el) {
        el.hidden = true;
      });
      return;
    }

    if (e.key !== 'Tab') return;
    var openDialog = document.querySelector(DIALOG_SELECTOR);
    if (!openDialog) return;

    var focusable = openDialog.querySelectorAll('a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* ---------- Newsletter popup ---------- */
  (function initNewsletterPopup() {
    var popup = document.getElementById('NewsletterPopup');
    if (!popup) return;

    var frequency = popup.getAttribute('data-popup-frequency') || 'session';
    var delay = parseInt(popup.getAttribute('data-popup-delay'), 10) || 0;
    var storageKey = 'nsc-newsletter-popup-seen';

    function alreadySeen() {
      if (frequency === 'always') return false;
      try {
        if (frequency === 'session') return sessionStorage.getItem(storageKey) === '1';
        if (frequency === 'day') {
          var last = localStorage.getItem(storageKey);
          if (!last) return false;
          return Date.now() - parseInt(last, 10) < 24 * 60 * 60 * 1000;
        }
      } catch (err) {
        return false;
      }
      return false;
    }

    function markSeen() {
      try {
        if (frequency === 'session') sessionStorage.setItem(storageKey, '1');
        if (frequency === 'day') localStorage.setItem(storageKey, String(Date.now()));
      } catch (err) { /* storage unavailable — ignore */ }
    }

    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]')) popup.hidden = true;
    });

    var form = popup.querySelector('form');
    var wasPostedBack = form && form.querySelector('.nsc-popup__success, [data-popup-error]');

    if (wasPostedBack) {
      popup.hidden = false;
      var invalidField = form.querySelector('[data-popup-error]') && form.querySelector('input[type="email"]');
      if (invalidField) invalidField.focus();
    } else if (!alreadySeen()) {
      window.setTimeout(function () {
        popup.hidden = false;
        markSeen();
        var firstField = popup.querySelector('input, textarea, select, button');
        if (firstField) firstField.focus();
      }, delay);
    }

    var copyButton = popup.querySelector('[data-copy-coupon]');
    if (copyButton) {
      copyButton.addEventListener('click', function () {
        var code = copyButton.getAttribute('data-copy-value') || '';
        var originalText = copyButton.textContent;

        function revert(delay) {
          window.setTimeout(function () { copyButton.textContent = originalText; }, delay);
        }

        function onSuccess() {
          copyButton.textContent = 'Copied!';
          revert(2000);
        }

        /* Both the Clipboard API and execCommand can be silently blocked inside a
           sandboxed iframe (e.g. the theme editor preview) — verify before claiming
           success, and fall back to selecting the visible text so the shopper can
           press Ctrl+C / Cmd+C themselves. */
        function onFailure() {
          selectCodeText();
          var isTouch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
          copyButton.textContent = isTouch ? 'Tap & hold the code to copy' : 'Press Ctrl+C to copy';
          revert(3000);
        }

        if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) {
          navigator.clipboard.writeText(code).then(onSuccess).catch(function () {
            if (fallbackCopy(code)) onSuccess();
            else onFailure();
          });
        } else if (fallbackCopy(code)) {
          onSuccess();
        } else {
          onFailure();
        }
      });
    }

    function selectCodeText() {
      var codeEl = popup.querySelector('[data-coupon-code]');
      if (!codeEl || !window.getSelection) return;
      var range = document.createRange();
      range.selectNodeContents(codeEl);
      var selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
    }

    function fallbackCopy(text) {
      /* iOS Safari won't copy from a readonly field and zooms on inputs under
         16px, so use an editable, 16px, off-screen textarea for the fallback. */
      var input = document.createElement('textarea');
      input.value = text;
      input.contentEditable = 'true';
      input.style.position = 'fixed';
      input.style.top = '0';
      input.style.left = '-9999px';
      input.style.fontSize = '16px';
      popup.appendChild(input);
      input.focus();
      input.select();
      input.setSelectionRange(0, text.length);
      var succeeded = false;
      try { succeeded = document.execCommand('copy'); } catch (err) { succeeded = false; }
      input.parentNode.removeChild(input);
      copyButton.focus();
      return succeeded;
    }
  })();

  /* ---------- Cart drawer + AJAX cart ---------- */
  var NSCCart = (function initCart() {
    var drawer = document.getElementById('CartDrawer');
    var body = drawer ? drawer.querySelector('[data-cart-drawer-body]') : null;
    var footer = drawer ? drawer.querySelector('[data-cart-drawer-footer]') : null;
    var subtotalEl = drawer ? drawer.querySelector('[data-cart-drawer-subtotal]') : null;
    var headerCount = document.querySelector('[data-cart-count]');

    function open() {
      if (!drawer) return;
      drawer.hidden = false;
      var closeBtn = drawer.querySelector('[data-cart-drawer-close]');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      if (drawer) drawer.hidden = true;
    }

    function updateHeaderCount(count) {
      if (!headerCount) return;
      headerCount.textContent = count;
      headerCount.hidden = count === 0;
    }

    function lineItemHtml(item) {
      var image = item.image ? '<img src="' + item.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_150x$1$2') + '" alt="' + (item.title || '') + '" width="70" height="88" loading="lazy">' : '';
      var variantTitle = item.variant_title ? '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>' : '';
      return (
        '<div class="cart-drawer__item" data-cart-line data-line-key="' + item.key + '">' +
          '<div class="cart-drawer__item-image">' + image + '</div>' +
          '<div class="cart-drawer__item-info">' +
            '<p class="cart-drawer__item-title">' + item.product_title + '</p>' +
            variantTitle +
            '<div class="cart-drawer__item-controls">' +
              '<div class="cart-drawer__qty">' +
                '<button type="button" class="cart-drawer__qty-btn" data-cart-qty-decrease aria-label="Decrease quantity">&minus;</button>' +
                '<span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
                '<button type="button" class="cart-drawer__qty-btn" data-cart-qty-increase aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button type="button" class="cart-drawer__item-remove" data-cart-drawer-remove>Remove</button>' +
            '</div>' +
          '</div>' +
          '<p class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</p>' +
        '</div>'
      );
    }

    function render(cart) {
      if (!body) return;
      updateHeaderCount(cart.item_count);

      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p><a href="' + (window.__nscRoutes ? window.__nscRoutes.allProducts : '/collections/all') + '" class="btn btn--secondary" data-cart-drawer-close>Continue shopping</a></div>';
        if (footer) footer.hidden = true;
        return;
      }

      body.innerHTML = cart.items.map(lineItemHtml).join('');
      if (footer) {
        footer.hidden = false;
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      }
    }

    function getCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }

    function refresh() {
      return getCart().then(function (cart) {
        render(cart);
        return cart;
      });
    }

    function addItem(variantId, quantity) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (data) {
              var err = new Error(data.description || 'Could not add to cart');
              err.isCartError = true;
              throw err;
            });
          }
          return r.json();
        })
        .then(function (result) {
          /* Refreshing the drawer is a display concern only — if it fails, the
             item is still in the cart, so this must never look like an add
             failure (that would trigger a duplicate add via the form fallback). */
          refresh()
            .then(function () { open(); })
            .catch(function () { open(); });
          return result;
        });
    }

    function changeItem(key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          render(cart);
          return cart;
        });
    }

    if (drawer) {
      drawer.addEventListener('click', function (e) {
        var lineEl = e.target.closest('[data-cart-line]');
        var key = lineEl ? lineEl.getAttribute('data-line-key') : null;
        if (!key) return;

        if (e.target.closest('[data-cart-drawer-remove]')) {
          changeItem(key, 0);
        } else if (e.target.closest('[data-cart-qty-increase]')) {
          var currentInc = parseInt(lineEl.querySelector('.cart-drawer__qty-value').textContent, 10) || 0;
          changeItem(key, currentInc + 1);
        } else if (e.target.closest('[data-cart-qty-decrease]')) {
          var currentDec = parseInt(lineEl.querySelector('.cart-drawer__qty-value').textContent, 10) || 0;
          changeItem(key, Math.max(0, currentDec - 1));
        }
      });
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-drawer-open]');
      if (opener) {
        e.preventDefault();
        refresh();
        open();
        return;
      }
      var closer = e.target.closest('[data-cart-drawer-close]');
      if (closer) close();
    });

    return { open: open, close: close, addItem: addItem, refresh: refresh };
  })();

  /* ---------- Product page: gallery + variant selection + add to cart ---------- */
  (function initProduct() {
    var form = document.getElementById('ProductForm');
    if (!form) return;

    var section = form.closest('[data-section-type="main-product"]');
    var productJsonEl = document.querySelector('[data-product-json]');
    var product = null;
    try {
      product = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
    } catch (err) {
      product = null;
    }

    /* Product gallery: thumbnails + prev/next arrows swap the active main image */
    var gallery = section ? section.querySelector('[data-gallery]') : null;
    if (gallery) {
      var galleryImages = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-image]'));
      var thumbs = section ? Array.prototype.slice.call(section.querySelectorAll('[data-thumb]')) : [];
      var prevBtn = gallery.querySelector('[data-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-gallery-next]');
      var activeIndex = 0;

      var showImage = function (index) {
        if (!galleryImages.length) return;
        activeIndex = (index + galleryImages.length) % galleryImages.length;
        galleryImages.forEach(function (img, i) { img.classList.toggle('is-active', i === activeIndex); });
        thumbs.forEach(function (thumb, i) { thumb.classList.toggle('is-active', i === activeIndex); });
      };

      section.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-thumb]');
        if (!thumb) return;
        showImage(parseInt(thumb.getAttribute('data-index'), 10) || 0);
      });

      if (prevBtn) prevBtn.addEventListener('click', function () { showImage(activeIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { showImage(activeIndex + 1); });
    }

    var variantIdInput = form.querySelector('[data-variant-id]');
    var addButton = form.querySelector('[data-add-to-cart]');
    var addButtonText = form.querySelector('[data-add-to-cart-text]');
    var addButtonPrice = form.querySelector('[data-add-to-cart-price]');
    var buyNowButton = form.querySelector('[data-buy-now]');
    var statusWrap = form.querySelector('[data-variant-status]');
    var optionInputs = Array.prototype.slice.call(form.querySelectorAll('[data-option-input]'));

    var stickyBar = section ? section.querySelector('[data-sticky-atc]') : null;
    var stickyButton = stickyBar ? stickyBar.querySelector('[data-sticky-atc-button]') : null;
    var stickyPrice = stickyBar ? stickyBar.querySelector('[data-sticky-atc-price]') : null;

    if (product) {
      function selectedOptions() {
        var groups = {};
        optionInputs.forEach(function (input) {
          if (input.checked) groups[input.name] = input.value;
        });
        return Object.keys(groups)
          .sort()
          .map(function (key) { return groups[key]; });
      }

      function findVariant(values) {
        return product.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === values[i]; });
        });
      }

      function updateForOptions() {
        var values = selectedOptions();
        var variant = findVariant(values);

        if (!variant) return;

        showFormError('');
        if (variantIdInput) variantIdInput.value = variant.id;

        if (addButtonPrice) addButtonPrice.textContent = formatMoney(variant.price);
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

        if (variant.available) {
          if (addButton) addButton.disabled = false;
          if (buyNowButton) buyNowButton.disabled = false;
          if (stickyButton) stickyButton.disabled = false;
          if (addButtonText) {
            addButtonText.innerHTML = 'Add to cart &mdash; <span data-add-to-cart-price>' + formatMoney(variant.price) + '</span>';
          }
          if (stickyButton) stickyButton.textContent = 'Add to cart';
        } else {
          if (addButton) addButton.disabled = true;
          if (buyNowButton) buyNowButton.disabled = true;
          if (stickyButton) stickyButton.disabled = true;
          if (addButtonText) addButtonText.textContent = 'Sold out';
          if (stickyButton) stickyButton.textContent = 'Sold out';
        }

        if (statusWrap) {
          statusWrap.innerHTML = '';
          if (!variant.available) {
            statusWrap.innerHTML = '<p class="product__stock product__stock--out">Sold out</p>';
          } else if (
            variant.inventory_management === 'shopify' &&
            typeof variant.inventory_quantity === 'number' &&
            variant.inventory_quantity > 0 &&
            window.__nscLowStockThreshold &&
            variant.inventory_quantity <= window.__nscLowStockThreshold
          ) {
            statusWrap.innerHTML = '<p class="product__stock product__stock--low">Only ' + variant.inventory_quantity + ' left</p>';
          }
        }

        document.dispatchEvent(new CustomEvent('nsc:variant-change', { detail: { variant: variant, product: product } }));
      }

      optionInputs.forEach(function (input) {
        input.addEventListener('change', updateForOptions);
      });
    }

    var formError = form.querySelector('[data-product-form-error]');
    function showFormError(message) {
      if (!formError) return;
      formError.textContent = message;
      formError.hidden = !message;
      /* The sticky mobile bar can trigger this while the form is off-screen */
      if (message) {
        var rect = formError.getBoundingClientRect();
        if (rect.top < 0 || rect.bottom > window.innerHeight) formError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    /* AJAX add-to-cart (falls back to a normal form submit if this throws before preventDefault) */
    function submitAddToCart(button, buttonTextEl) {
      var variantId = variantIdInput ? variantIdInput.value : null;
      if (!variantId) return;
      var originalText = buttonTextEl ? buttonTextEl.innerHTML : (button ? button.textContent : '');
      if (button) button.disabled = true;
      if (buttonTextEl) buttonTextEl.textContent = 'Adding…';
      else if (button) button.textContent = 'Adding…';

      showFormError('');
      NSCCart.addItem(variantId, 1)
        .catch(function (err) {
          /* A 422 from Shopify (e.g. asking for more than is in stock) carries a
             readable description — show it here rather than bouncing to the cart. */
          if (err && err.isCartError) showFormError(err.message);
          else form.submit();
        })
        .then(function () {
          if (button) button.disabled = false;
          if (buttonTextEl) buttonTextEl.innerHTML = originalText;
          else if (button) button.textContent = originalText;
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submitAddToCart(addButton, addButtonText);
    });

    /* Buy it now: add the selected variant then jump straight to checkout, skipping the cart page */
    function submitBuyNow(button) {
      var variantId = variantIdInput ? variantIdInput.value : null;
      if (!variantId) return;
      var originalText = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.textContent = 'Redirecting…';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (data) {
              var err = new Error(data.description || 'Could not add to cart');
              err.isCartError = true;
              throw err;
            });
          }
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          if (err && err.isCartError) {
            showFormError(err.message);
            if (button) {
              button.disabled = false;
              button.textContent = originalText;
            }
            return;
          }
          /* Fall back to a plain GET add-to-cart, which redirects to return_to without needing JS */
          window.location.href = '/cart/add?id=' + encodeURIComponent(variantId) + '&quantity=1&return_to=' + encodeURIComponent('/checkout');
        });
    }

    if (buyNowButton) {
      buyNowButton.addEventListener('click', function () {
        submitBuyNow(buyNowButton);
      });
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        submitAddToCart(stickyButton, null);
      });
    }

    /* Sticky add-to-cart bar: show once the real button scrolls out of view, mobile only */
    if (stickyBar && addButton && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.hidden = entry.isIntersecting || window.innerWidth >= 750;
        });
      }, { threshold: 0 });
      observer.observe(addButton);

      window.addEventListener('resize', function () {
        if (window.innerWidth >= 750) stickyBar.hidden = true;
      });
    }
  })();

  /* ---------- Product card image slideshow (auto-advance + dots) ---------- */
  (function initProductCardSlideshows() {
    var cards = document.querySelectorAll('[data-card-slideshow]');
    cards.forEach(function (card) {
      var images = Array.prototype.slice.call(card.querySelectorAll('[data-card-image]'));
      var dots = Array.prototype.slice.call(card.querySelectorAll('[data-card-dot]'));
      if (images.length < 2) return;

      var current = 0;
      var timer = null;

      function show(index) {
        current = (index + images.length) % images.length;
        images.forEach(function (img, i) { img.classList.toggle('is-active', i === current); });
        dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === current); });
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      function start() {
        stop();
        timer = window.setInterval(function () { show(current + 1); }, 5000);
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          show(i);
          start();
        });
      });

      start();
    });
  })();

  /* ---------- Sticky shop CTA (homepage campaign section) ---------- */
  (function initStickyShopCta() {
    var button = document.querySelector('[data-shop-cta-button]');
    var bar = document.querySelector('[data-sticky-shop-cta]');
    if (!button || !bar || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.hidden = entry.isIntersecting;
      });
    }, { threshold: 0 });
    observer.observe(button);
  })();

  /* ---------- Cart page: remove-item convenience (sets qty to 0, submits form) ---------- */
  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (!removeBtn) return;
    var row = removeBtn.closest('[data-cart-line]');
    if (!row) return;
    var qtyInput = row.querySelector('[data-cart-qty]');
    if (qtyInput) qtyInput.value = 0;
    var form = removeBtn.closest('form');
    if (form) form.submit();
  });
})();
